import React from 'react';

const InnerBox = props => {
	const {children} = props;

	return <div style={{marginLeft: 'auto', marginRight: 'auto'}}>{children}</div>;
};

export default InnerBox;
